import React from "react";

import { useMutation } from "@apollo/client";

/** components */
import { classNames } from "primereact/utils";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";

/** services */
import { login as LoginLocal } from "./../services/auth";

/** context */
import { useSettings } from "../context/settings";

/** QUERIES & MUTATIONS */
import CREATE_USER, { LOGIN } from "../provider/Users/mutation";

/** utils */
import { getGraphsqErros, maskPhone } from "./../utilities/functions";

export const Login = (props: any) => {
    const [login] = useMutation(LOGIN);

    const settings = useSettings();

    const [loading, setLoading] = React.useState<boolean>(false);
    const [submitted, setSubmitted] = React.useState<boolean>(false);

    const [phone, setPhone] = React.useState("");
    const [password, setPassword] = React.useState("");

    async function _userAuth() {
        setLoading(true);
        setSubmitted(true);

        if (!phone || !password) return;

        login({ variables: { data: { phone: phone, password } } })
            .then(e => {
                setLoading(false);
                LoginLocal(e.data.login);
                document.location.href = "/";
            })
            .catch(e => {
                setLoading(false);
                settings.setErrorMessage(getGraphsqErros(e));
                settings.setVisibleError(true);
            });
    }

    return (
        <div className="login-body">
            <div className="login-image">
                <img src={`assets/layout/images/pages/login-onlight.jpg`} alt="Missões Espontâneas" />
            </div>

            <div className="login-panel p-fluid">
                <form
                    onSubmit={e => {
                        e.preventDefault();
                        _userAuth();
                    }}>
                    <div className="flex flex-column">
                        <div className="flex align-items-center mb-6 logo-container">
                            <img
                                src={`assets/layout/images/logo-${props.colorScheme === "light" ? "dark" : "light"}.png`}
                                className="login-logo"
                                alt="login-logo"
                            />
                            <h3 className="ml-2">Missões Espontâneas</h3>
                        </div>
                        <div className="form-container">
                            <div className="field text-left">
                                <span className="p-input-icon-left">
                                    <i className="pi pi-phone"></i>
                                    <InputText
                                        autoComplete="new-password"
                                        type="text"
                                        placeholder="(00) 0 0000-0000"
                                        value={phone}
                                        onChange={e => setPhone(maskPhone(e.target.value))}
                                        autoFocus
                                        className={classNames("pt-3 pb-3 ", { "p-invalid": submitted && !phone })}
                                    />
                                </span>
                                {submitted && !phone && <small className="p-invalid">Telefone é obrigatório.</small>}
                            </div>

                            <div className="field text-left">
                                <span className="p-input-icon-left">
                                    <i className="pi pi-key"></i>
                                    <InputText
                                        autoComplete="new-password"
                                        type="password"
                                        placeholder="***"
                                        value={password}
                                        onChange={e => setPassword(e.target.value)}
                                        className={classNames("pt-3 pb-3 ", { "p-invalid": submitted && !password })}
                                    />
                                </span>
                                {submitted && !password && <small className="p-invalid">Senha é obrigatório.</small>}
                            </div>
                        </div>
                        <div className="button-container">
                            <Button type="submit" disabled={loading} label={loading ? "AUTENTICANDO..." : "ENTRAR"} className="p-3" />
                        </div>
                    </div>
                </form>

                <div className="login-footer flex align-items-center">
                    <span>Todos direitos reservados 2022</span>
                </div>
            </div>
        </div>
    );
};
